export function formatCredits(credits: number) {
  return `${credits}C`
}

export function formatCreditsLong(credits: number) {
  return `${credits} Credit${credits === 1 ? '' : 's'}`
}
